import {Reducer} from "redux";
import {
    ALL_FILES_UPLOADED,
    FILE_UPLOADED,
    FileUploadActions,
    UPLOAD_FILES,
    UPLOADING_PROGRESS
} from "../store/file-upload-types";
import {AlbumInfo} from "../models/responses";

export interface FileUploadState {
    files: File[]
    album?: AlbumInfo
    fileProgress?: {
        file: File,
        progress: number
    }
}

const initialState: FileUploadState = {files: []}

export const uploadFileReducer: Reducer<FileUploadState, FileUploadActions> = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_FILES:
            return {
                ...state,
                files: action.files,
                album: action.album,
                fileProgress: {file: action.activeFile, progress: 0}
            }
        case ALL_FILES_UPLOADED:
            return {...state, files: [], fileProgress: undefined, album: undefined}
        case UPLOADING_PROGRESS:

            return state
        case FILE_UPLOADED:
            return state
        default:
            return state
    }
}